import React, { useContext } from 'react';
import { Formik, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { api_srv } from 'services';
import { useQuery } from 'react-query';
import { DashboardContext } from 'context/DashboardContext';
import { useQueryClient } from 'react-query';

const validationSchema = Yup.object({
  underwriterSystemRef: Yup.string().required('Underwriter is required'),
  requestRemarks: Yup.string().max(500, 'Remarks must be 500 characters or less'),
});

const get_my_underwriters = async () => {
  const resp = await (await api_srv).fetchAllUnderwriters();
  return resp.data || [];
};

function Add_Panel_Request(props) {
  const { setRequest } = useContext(DashboardContext);
  const queryClient = useQueryClient();

  const {
    data: underwriters = [],
    isLoading: isMyUnderwritersLoading,
    isError: isMyUnderwritersError,
    refetch: refetchUnderwriters, // optional: refresh underwriters if needed
  } = useQuery("myunderwriters", get_my_underwriters, {
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    try {
      const payload = {
        underwriterSystemRef: values.underwriterSystemRef,
        requestRemarks: values.requestRemarks || null,
      };

      // Update context if needed
      setRequest(payload);

      // Call parent onSubmit if provided (e.g. for modal close)
      if (props.onSubmit) {
        props.onSubmit(payload);
      }

      // THIS IS KEY: Refetch the requests list in the parent
      if (typeof props.refetchRequests === 'function') {
        await props.refetchRequests(); // Wait for fresh data\
      }
      queryClient.invalidateQueries({ queryKey: ['myRequests'] });

      // Optional: show success feedback
      // toast.success("Panel request sent successfully!");

      resetForm();
    } catch (error) {
      console.error("Submit error:", error);
      // toast.error("Failed to submit request");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ padding: '0.5rem', maxWidth: '600px', margin: '0 auto' }}>
      <Formik
        initialValues={{
          underwriterSystemRef: '',
          requestRemarks: '',
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ isSubmitting, touched, errors, values, handleChange, handleBlur, resetForm }) => (
          <Form noValidate>
            {/* Underwriter Selection */}
            <div style={{ marginBottom: '1.5rem' }}>
              <label htmlFor="underwriterSystemRef" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Underwriter <span style={{ color: 'red' }}>*</span>
              </label>

              {isMyUnderwritersLoading ? (
                <div style={{ padding: '0.75rem', color: '#6c757d' }}>Loading underwriters...</div>
              ) : isMyUnderwritersError ? (
                <div style={{ padding: '0.75rem', color: '#dc3545' }}>
                  Failed to load underwriters{' '}
                  <button type="button" onClick={() => refetchUnderwriters()} style={{ marginLeft: '10px', textDecoration: 'underline' }}>
                    Retry
                  </button>
                </div>
              ) : (
                <select
                  id="underwriterSystemRef"
                  name="underwriterSystemRef"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.underwriterSystemRef}
                  className={`form-control ${touched.underwriterSystemRef && errors.underwriterSystemRef ? 'is-invalid' : ''}`}
                  style={{ width: '100%', padding: '0.05rem', borderRadius: '6px', fontSize: '1rem' }}
                  disabled={isSubmitting}
                >
                  <option value="">Select Underwriter</option>
                  {underwriters.map((uw) => (
                    <option key={uw.underwriterSystemRef} value={uw.underwriterSystemRef}>
                      {uw.name}
                    </option>
                  ))}
                </select>
              )}

              <ErrorMessage name="underwriterSystemRef" component="div" className="invalid-feedback" />
            </div>

            {/* Remarks */}
            <div style={{ marginBottom: '1.5rem' }}>
              <label htmlFor="requestRemarks" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Request Remarks (Optional)
              </label>
              <textarea
                id="requestRemarks"
                name="requestRemarks"
                rows={5}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.requestRemarks}
                className={`form-control ${touched.requestRemarks && errors.requestRemarks ? 'is-invalid' : ''}`}
                style={{ width: '100%', padding: '0.75rem', borderRadius: '6px', fontSize: '1rem', resize: 'vertical' }}
                placeholder="Provide additional context or special instructions..."
                disabled={isSubmitting}
              />
              <ErrorMessage name="requestRemarks" component="div" className="invalid-feedback" />
            </div>

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
              <button
                type="submit"
                disabled={isSubmitting || isMyUnderwritersLoading}
                className="btn btn-primary px-4"
                style={{
                  padding: '0.75rem 1.5rem',
                  fontWeight: '500',
                }}
              >
                {isSubmitting ? (
                  <>
                    <i className="fa fa-circle-notch fa-spin" style={{ marginRight: '8px' }}></i>
                    Submitting...
                  </>
                ) : (
                  'Submit Request'
                )}
              </button>

              <button
                type="button"
                onClick={() => resetForm()}
                className="btn btn-secondary px-4"
                disabled={isSubmitting}
                style={{ padding: '0.75rem 1.5rem' }}
              >
                Clear
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default Add_Panel_Request;